import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Pagination from "react-js-pagination";
import './styles/tae.css';

import TopTitle from './TopTitle'
import { instance } from './common';

function Loadlist({history}) {
    const [params, setParams] = useState({
        nt_type:'n_title',
        keyword:'',
    });

    const {nt_type,keyword} = params;

    const onChangeParams = (e) => {
        const {name,value} = e.target;
        setParams({
            ...params,
            [name]:value
        });
    }

    const [data, setData] = useState([]);
    const ppp = 10;
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    let obj = {
        page: page,
        ppp: ppp,
        value: nt_type,
        keyword: keyword
    }

    useEffect(() => {

        const fetchData = async () => {
            instance.post('/notice/all', obj).then(function (res) {
                console.log('res.data.rows : ', res.data.rows);
                setData(res.data.rows);
                setTotal(res.data.totalCount);
            });
        };

        fetchData();

    }, [page,nt_type,keyword]);
    

    const pageChange = (pageNumber) => {
        setPage(pageNumber);
    }

    const goLink = (e) => {
        const {n_id} = e.target.dataset;
        history.push('/noticedetail?n_id='+n_id);
    }

    return (
        <>
            <InputGroup 
            keyword={keyword} 
            onChangeParams={onChangeParams}
            nt_type={nt_type}
            />
            <table className="table mb-5">
                <thead className="nl_thead">
                    <tr className="nl_theadtr">
                        <td className="text-center">No</td>
                        <td className="text-center">제목</td>
                        <td className="text-center">작성일</td>
                    </tr>
                </thead>
                <tbody>
                    {
                    
                         data.map((v,i) => <tr className="nl_tbodytr">
                         <td className="text-center">{total-i}</td>
                         <td className="nl_blue text-center" onClick={goLink} data-n_id={v.n_id}>{v.n_title}</td>
                         <td className="text-center">{v.n_date}</td>
                     </tr>)
                        
                    }
                </tbody>
            </table>
            <div className="d-flex wrap-page">
                <Pagination
                    activePage={page}
                    itemsCountPerPage={10}
                    totalItemsCount={total}
                    pageRangeDisplayed={10}
                    onChange={pageChange}
                />
            </div>
        </>
    )
}

function InputGroup({nt_type,keyword,onChangeParams}) {
    const searchKeyword= () => {
        <Loadlist />
    }

    return (
        <>
            <div className="nl_flex position-relative mb-5">
                <div className="pl-0 col-4 n_title_box">
                    <select className="form-control nl_form" name="nt_type" value={nt_type} onChange={onChangeParams}>
                        <option value="n_title">제목</option>
                    </select>
                </div>
                <div className="col-8 pr-0 position-relative n_input_box">
                    <input className="nl_input" onChange={onChangeParams}  name="keyword" value={keyword} placeholder="검색어를 입력하세요" />
                    <span className="nl_search d-block" onClick={searchKeyword}></span>
                </div>
            </div>
        </>
    )
}


function NoticeList({history}) {
    return (

        <Container className="position-relactive">
            <div className="c_pad">
                <TopTitle title="공지 및 소식" />
                <Loadlist history={history}/>
            </div>
        </Container>

    );
}

export default NoticeList;